import { axios } from '@/utils/request'

/**
 *
 * @param parameter
 * @returns {*}
 */

// 登录
export function appLogin (parameter) {
  return axios({
    url: '/auth/app/login',
    method: 'post',
    params: parameter
  })
}

// 工程
export function listEngineer (parameter) {
  return axios({
    url: '/sso/api/sso/base/ssoEngineering/listByUser',
    method: 'get',
    params: parameter
  })
}

// 标段
export function listSection (parameter) {
  return axios({
    url: 'sso/api/sso/base/ssoSection/listByUser',
    method: 'get',
    params: parameter
  })
}

// 检测地点
export function environmentMonitorPlace (parameter) {
  return axios({
    url: 'environment/api/environment/base/environmentMonitorPlace/listBySectionId',
    method: 'get',
    params: parameter
  })
}

// 设备列表
export function environmentMonitorDevice (parameter) {
  return axios({
    url: 'environment/api/environment/base/environmentMonitorDevice/list',
    method: 'get',
    params: parameter
  })
}

// 通过sn查询最新实时数据
export function environmentMonitorData (parameter) {
  return axios({
    url: 'environment/api/environment/data/environmentMonitorData/selectLastData',
    method: 'get',
    params: parameter
  })
}

// // 历史数据查询接口
// export function getNewestRealTimeData (parameter) {
//   return axios({
//     url: '/environmentMonitorServer/getNewestRealTimeData',
//     method: 'get',
//     params: parameter
//   })
// }

// export function ByCollectTime (parameter) {
//     return axios({
//       url: '/environmentMonitorServer/getEnvironmentalMonitorEntityByCollectTime',
//       method: 'get',
//       params: parameter
//     })
//   }

// //初始话筛选框
// export function initScreenData (parameter) {
//   return axios({
//     url: '/environmentMonitorServer/initScreenData',
//     method: 'get',
//     params: parameter
//   })
// }